import { css } from '@emotion/react'
 /** @jsxImportSource @emotion/react */
import React,{useEffect, useState} from 'react'
import jwt_decode from "jwt-decode";
import { Form, Input ,Select } from 'antd';
import {ButtonBase} from '@mui/material';
import config from '../../config'
import axios from '../apiClient';
import Alert from '../alert';
import Loader from '../loader';
import { useLocation } from 'react-router-dom';
const { Option } = Select;

export default function EditSubAgent() {
  const [loading,setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const location = useLocation();
  console.log(location.state)
  const {id: agentId} = location.state;
  
  const onFinish = async ({phNum: phoneNumber,password}) => {
    setLoading(true)
    if(!password) password = "";
    const params ={agentId,phoneNumber,password}
    const data = await axios.put(`/agent/editSubAgent`,params)
    let msgObj = { code: data.code, msg: data.message }
    if(data.code == 200) msgObj.msg = "Successfully edited the sub agent"
    setErrorMsg(msgObj)
    setLoading(false)
    setOpenAlert(true)
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
  return (
    <div
      css={css`
        /* background-color: #ffffff; */
        border-radius: 1rem;
        padding: 1rem;
        margin: 0 10rem;
      `}
    >
        {/* <h2 style={{fontWeight: 'normal',marginBottom: "2rem"}}>Edit User</h2> */}
      <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
      <Form
        name="basic"
        className="create-user"
        style={{
          fontFamily: "inherit",
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Upper />
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            padding: "0 2rem",
            marginTop: "2rem",
          }}
        >
          <ButtonBase
            type="submit"
            component="button"
            style={{
              color: "white",
              display: "flex",
              backgroundColor: "#5e35b1",
              padding: "0.6rem 1.8rem",
              borderRadius: "2rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
             {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Edit</h4>}
          </ButtonBase>
        </div>
      </Form>
    </div>
  );
}

const Upper = () =>{
  const location = useLocation();
  const {name,phone_number} = location.state;
  const validatePassword = (_, value) => {
    if (value && !/(?=.*[A-Z])(?=.*\d).{8,}/.test(value)) {
      return Promise.reject(
        'Password must contain at least one capital letter, one number, and be at least 8 characters long'
      );
    }
    return Promise.resolve();
  };
  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Username"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="name"
          style={{ padding: "0 0.4rem", color: "white" }}
          initialValue={name}
        >
          <Input   size="large"  disabled
          />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Phone Number"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="phNum"
          style={{ padding: "0 0.4rem", color: "white" }}
          initialValue={phone_number}
        >
          <Input  size="large" />
        </Form.Item>
        
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Password"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="password"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              validator: validatePassword
            },
          ]}
        >
          <Input.Password
            css={css`
              :hover {
                border-color: red;
              }
            `}
            size="large"
          />
        </Form.Item>
      </div>

    </div>
  );
}